import PropTypes from 'prop-types';
import { Button, ModalGeneric, Table } from 'ypf-pas-general-ui-components';
import { BsDownload } from 'react-icons/bs';
import './ModalSummaryApprovalPending.scss';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

import useToast from '../../../../hooks/useToast';
import { bulidFilterWorkReportRequestNoPage } from '../../../../page/ServiceRequest/FilterServiceRequest/utils/filterServiceRequestUtils';
import { useFilterContext } from '../../../../context/FilterContext';
import { downloadExcelSummaryPending } from '../../../../services/workReport';

const ModalSummaryApprovalPending = ({ showSummaryModal, workReportData, handleSummaryModal }) => {
  const { setNewToast } = useToast();
  const { filter } = useFilterContext();

  const columnsTableModalSummaryApprovalPending = [
    {
      Header: 'Contrato',
      accessor: 'numeroContrato',
      hideSort: true
    },
    {
      Header: 'Proveedor',
      accessor: 'proveedor',
      hideSort: true,
      style: {
        width: '350px'
      },
      Cell: (row) => {
        const { value } = row;

        return (
          <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} placement="top">
            <div className="text-ellipsis-clamp">{value}</div>
          </OverlayTrigger>
        );
      }
    },
    {
      Header: 'Part.pend.',
      accessor: 'cantidadPartesPendientes',
      hideSort: true
    },
    {
      Header: 'Fecha min.',
      accessor: 'fechaMin',
      hideSort: true
    },
    {
      Header: 'Fecha max.',
      accessor: 'fechaMax',
      hideSort: true
    }
  ];

  const handleOnClickDownloadWorkReports = async () => {
    try {
      const { filters } = bulidFilterWorkReportRequestNoPage({
        filters: filter,
        isPending: true
      });

      await downloadExcelSummaryPending(filters);

      setNewToast({
        type: 'SUCCESS',
        message: 'Se ha descargado el archivo correctamente'
      });
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={() => handleSummaryModal(false)}
      show={showSummaryModal}
      size="xl"
      title="Resumen"
    >
      <Row className="container-summary-header">
        <Col sm={6}>
          <div className="container-title-total">
            <h2 className="title-total">Partes de trabajo</h2>
            <div className="total-result">{workReportData?.total}</div>
          </div>
        </Col>
        <Col className="download-button" sm={6}>
          <Button
            className="linkButtons"
            color="primary"
            icon={BsDownload}
            iconRight
            label="Descargar .xlsx"
            onClick={() => handleOnClickDownloadWorkReports()}
            type="button"
            variant="light-gray"
            widthButton="160px"
          />
        </Col>
      </Row>
      <Row>
        <div className="container-table-summary scroll-table-summary">
          <Table
            columns={columnsTableModalSummaryApprovalPending}
            data={workReportData?.data || []}
            titleLeft
            type="light"
          />
        </div>
      </Row>
    </ModalGeneric>
  );
};

ModalSummaryApprovalPending.propTypes = {
  showSummaryModal: PropTypes.bool,
  workReportData: PropTypes.shape({
    total: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  handleSummaryModal: PropTypes.func
};

ModalSummaryApprovalPending.defaultProps = {
  showSummaryModal: false,
  handleSummaryModal: () => {}
};
export default ModalSummaryApprovalPending;
